import config from 'config'
import { getJsonHeaders } from './helpers'

export async function list(limit = 15, page = 1) {
  const result = await fetch(
    config.API_URL + `/iapi/packages?per_page=${limit}&page=${page}`,
    { credentials: 'include' }
  )
  return await result.json()
}

export async function get(id) {
  const result = await fetch(config.API_URL + `/iapi/packages/${id}`, {
    credentials: 'include',
  })
  return await result.json()
}

export async function create(body) {
  const res = await fetch(config.API_URL + `/iapi/packages`, {
    method: 'POST',
    headers: await getJsonHeaders(),
    credentials: 'include',
    body: JSON.stringify(body),
  })

  return {
    success: res.status === 201,
    data: await res.json(),
  }
}

export async function update(id, body) {
  const res = await fetch(config.API_URL + `/iapi/packages/${id}`, {
    method: 'PUT',
    headers: await getJsonHeaders(),
    credentials: 'include',
    body: JSON.stringify(body),
  })

  return {
    success: res.status === 200,
    data: await res.json(),
  }
}

export async function deletePackage(id) {
  const res = await fetch(config.API_URL + `/iapi/packages/${id}`, {
    method: 'DELETE',
    headers: await getJsonHeaders(),
    credentials: 'include',
  })

  return res.status === 204
}

export async function requestNewPackage(body) {
  const res = await fetch(config.API_URL + `/iapi/packages/request-new`, {
    method: 'POST',
    headers: await getJsonHeaders(),
    credentials: 'include',
    body: JSON.stringify(body),
  })

  return {
    success: res.status === 200,
    data: await res.json(),
  }
}
